import { Tooltip } from "@mui/material"
import {
  CancelFilledOutlined,
  CheckCircleFilledOutlined,
  DoNotDisturbOnFilledOutlined,
  WarningOutlined,
} from "@mui-symbols-material/w300"
import type { FC, ReactElement } from "react"

interface InventoryLotStatusIconProps {
  qaStatus: string | null | undefined
}

const STATUS_TO_METADATA: Record<string, { label: string; icon: ReactElement }> = {
  R: { label: "Rejected", icon: <CancelFilledOutlined className='text-secondary' fontSize='small' /> },
  H: { label: "On Hold", icon: <WarningOutlined className='text-tertiary-yellow-500' fontSize='small' /> },
  A: { label: "Approved", icon: <CheckCircleFilledOutlined className='text-tertiary-green-500' fontSize='small' /> },
  "": {
    label: "Not Evaluated",
    icon: <DoNotDisturbOnFilledOutlined className='text-gray-400' fontSize='small' />,
  },
} as const

export const InventoryLotStatusIcon: FC<InventoryLotStatusIconProps> = ({ qaStatus }) => {
  const { label, icon } = STATUS_TO_METADATA[qaStatus ?? ""]

  return (
    <Tooltip title={label} placement='top'>
      {icon}
    </Tooltip>
  )
}
